import { TranslationMap } from '@trimble-gcs/i18n-types';

export function listFiltersTranslations() {
  return {
    title: {
      text: $localize`:@@listFilters.title:Filters`,
      desc: 'Title for the filters panel that provides various filters to apply to your dataset.',
    },
    close: {
      tooltip: {
        text: $localize`:@@listFilters.close.tooltip:Close`,
        desc: 'Tooltip for the top right "X" button that closes the filters panel.',
      },
    },
    inputs: {
      name: {
        label: {
          text: $localize`:@@listFilters.inputs.name.label:Name`,
          desc: 'Label for the name filter input.',
        },
      },
      status: {
        label: {
          text: $localize`:@@listFilters.inputs.status.label:Status`,
          desc: 'Label for the status filter multi-select dropdown.',
        },
        options: {
          uploading: {
            text: $localize`:@@listFilters.inputs.status.options.uploading:Uploading`,
            desc: 'Option in the status filter multi-select dropdown list.',
          },
          processing: {
            text: $localize`:@@listFilters.inputs.status.options.processing:Processing`,
            desc: 'Option in the status filter multi-select dropdown list.',
          },
          ready: {
            text: $localize`:@@listFilters.inputs.status.options.ready:Ready`,
            desc: 'Option in the status filter multi-select dropdown list.',
          },
          failed: {
            text: $localize`:@@listFilters.inputs.status.options.failed:Failed`,
            desc: 'Option in the status filter multi-select dropdown list.',
          },
        },
      },
      uploadDate: {
        label: {
          text: $localize`:@@listFilters.inputs.uploadDate.label:Upload Date`,
          desc: 'Label for the upload date range filter input.',
        },
        fromPlaceholder: {
          text: $localize`:@@listFilters.inputs.uploadDate.fromPlaceholder:From`,
          desc: 'Placeholder for the upload date from filter input.',
        },
        toPlaceholder: {
          text: $localize`:@@listFilters.inputs.uploadDate.toPlaceholder:To`,
          desc: 'Placeholder for the upload date to filter input.',
        },
      },
      captureDate: {
        label: {
          text: $localize`:@@listFilters.inputs.captureDate.label:Capture Date`,
          desc: 'Label for the capture date range filter input.',
        },
        fromPlaceholder: {
          text: $localize`:@@listFilters.inputs.captureDate.fromPlaceholder:From`,
          desc: 'Placeholder for the capture date from filter input.',
        },
        toPlaceholder: {
          text: $localize`:@@listFilters.inputs.captureDate.toPlaceholder:To`,
          desc: 'Placeholder for the capture date to filter input.',
        },
      },
      scannerType: {
        label: {
          text: $localize`:@@listFilters.inputs.scannerType.label:Scanner Type`,
          desc: 'Label for the scanner type filter input.',
        },
        placeholder: {
          text: $localize`:@@listFilters.inputs.scannerType.placeholder:Begin typing to search...`,
          desc: 'Placeholder for the scanner type filter input.',
        },
        none: {
          text: $localize`:@@listFilters.inputs.scannerType.none:-- No Scanner Type --`,
          desc: 'Option in the scanner type filter list to return a dataset where items contain no scanner type.',
        },
      },
      tags: {
        label: {
          text: $localize`:@@listFilters.inputs.tags.label:Tags`,
          desc: 'Label for the tags filter input.',
        },
        placeholder: {
          text: $localize`:@@listFilters.inputs.tags.placeholder:Begin typing to search...`,
          desc: 'Placeholder for the tags filter input.',
        },
        none: {
          text: $localize`:@@listFilters.inputs.tags.none:-- No Tags --`,
          desc: 'Option in the tags filter list to return a dataset where items contain no tags.',
        },
      },
      tagsMatch: {
        label: {
          text: $localize`:@@listFilters.inputs.tagsMatch.label:Search tags individually or a combination of`,
          desc: 'Label for the tags match filter option to use. Filtering using match option "ALL" or "ANY".',
        },
        optionAll: {
          text: $localize`:@@listFilters.inputs.tagsMatch.optionAll:All`,
          desc: 'Label for the tags match radio button option "ALL".',
        },
        optionAny: {
          text: $localize`:@@listFilters.inputs.tagsMatch.optionAny:Any`,
          desc: 'Label for the tags match radio button option "ANY".',
        },
      },
      uploadedBy: {
        label: {
          text: $localize`:@@listFilters.inputs.uploadedBy.label:Uploaded By`,
          desc: 'Label for the uploaded by filter input.',
        },
      },
      hasClassifications: {
        label: {
          text: $localize`:@@listFilters.inputs.hasClassifications.label:Classified`,
          desc: 'Label for the contains classifications toggle switch filter.',
        },
      },
      hasStations: {
        label: {
          text: $localize`:@@listFilters.inputs.hasStations.label:Contains Station(s)`,
          desc: 'Label for the contains stations toggle switch filter.',
        },
      },
      multiSelected: {
        two: {
          text: $localize`:@@listFilters.inputs.multiSelected.two:{firstSelected} (+ 1 other)`,
          desc:
            'Text displayed when two options have been selected from a multi-select dropdown list. ' +
            '{firstSelected} is the text of the first selected item from the dropdown list.',
        },
        many: {
          text: $localize`:@@listFilters.inputs.multiSelected.many:{firstSelected} (+ {otherCount} others)`,
          desc:
            'Text displayed when more than two options have been selected a multi-select dropdown list. ' +
            '{firstSelected} is the text of the first selected item from the dropdown list.' +
            '{otherCount} is the total number of items selected from the dropdown list minus one.',
        },
      },
    },
    clear: {
      text: $localize`:@@listFilters.clear:Clear Filters`,
      desc: 'Text for the clear filters button.',
    },
    apply: {
      text: $localize`:@@listFilters.apply:Apply Filters`,
      desc: 'Text for the apply filters button.',
    },
  } satisfies TranslationMap;
}
